import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { get, find } from 'lodash';
import { bindActionCreators } from 'redux';

import marketActions from './actions/markets';
import wranglerActions from './actions/wranglers';
import vehicleActions from './actions/vehicles';
import settingsActions from './actions/settings';
import WrappedSpinner from './components/common/wrapped-spinner';

import SnackbarSuccess from './components/common/snackbarSuccess';
import SnackbarError from './components/common/snackbarError';
import MainMenu from './components/common/main-menu';
import MenuAppBar from './components/operator/app-bar';

function Operator(props) {
  const {
    auth,
    wranglers,
    fetchSettings,
    fetchWranglers,
    fetchMarkets,
    setActiveWrangler,
  } = props;
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchSettings().catch(() => auth.logout());
    fetchWranglers();

    document.title = 'Wrangler';
  }, []);

  useEffect(() => {
    if (!wranglers) return;

    const userPhone = localStorage.getItem('userPhone');
    const matchingWrangler = find(
      wranglers || [],
      (wrangler) => wrangler.phoneNumber === userPhone,
    );

    if (!matchingWrangler) {
      setIsLoading(false);
      return auth.blockFromAdmin();
    }
    const username = get(matchingWrangler, 'email', 'Unknown');
    const firstName = get(matchingWrangler, 'firstName', 'Unknown');
    const lastName = get(matchingWrangler, 'lastName', '');
    const wranglerId = get(matchingWrangler, '_id');
    const userMarketPreferences = get(matchingWrangler, 'adminMarketIds', []);

    localStorage.setItem('username', username);
    localStorage.setItem('userFullName', `${firstName} ${lastName}`);
    localStorage.setItem('wranglerId', wranglerId);
    localStorage.setItem('userId', wranglerId);
    localStorage.setItem('userMarketPreferences', JSON.stringify(userMarketPreferences));

    setIsLoading(false);
    setActiveWrangler(matchingWrangler);
    fetchMarkets();
  }, [wranglers]);

  const onHomeRoute = () => {
    const { isExact } = get(props, 'match');
    return isExact;
  };

  return (
    <WrappedSpinner isLoading={isLoading}>
      <MenuAppBar auth={auth} />
      {onHomeRoute() && <MainMenu />}
      <SnackbarSuccess />
      <SnackbarError />
    </WrappedSpinner>
  );
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...marketActions,
  ...wranglerActions,
  ...vehicleActions,
  ...settingsActions,
}, dispatch);

const mapStateToProps = ({ wranglers }) => ({
  wranglers: wranglers.wranglers,
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Operator));
